"use client";

/* eslint-disable @typescript-eslint/no-explicit-any */

/* eslint-disable react-hooks/exhaustive-deps */

import { useRouter } from "next/navigation";
import { useEffect, useMemo, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import HelpOverLayButton from "@/app/shared-components/help-overlay-button/help-overlay-button-wizard";
import { useWizard } from "@/app/shared-providers/wizard-context-provider";
import LabelButtonWrapper from "@/components/atoms/button-wrapper/button-wrapper";
import RichText from "@/components/atoms/rich-text/rich-text";
import Logo from "@/components/molecules/logo-component/logo";
import getAcoData from "@/components/organisms/quote/acos/dynamic-data-map/map-aco-data";
import {
  SubmitVoucherCode,
  useSubmitCodes,
} from "@/hooks/api/review-api/apply-promo";
import { useRemoveCover } from "@/hooks/api/review-api/remove-cover";
import useGtmQuoteReviewOption from "@/hooks/gtm/quote-review/use-gtm-quote-review-options";
import useMediaQuery from "@/hooks/use-media-query/use-media-query";
import { useQuoteDisabled } from "@/hooks/use-quote-disabled/use-quote-disabled";
import { useWizardTranslation } from "@/libs/i18n/use-wizard-translation";
import { useLoading } from "@/providers/loading-provider";
import { RootState } from "@/store/root-reducer";
import { updateQuote } from "@/store/slices/quote/quote.slice";
import { OptionalExtra } from "@/types/OptionalExtraType";
import { PolicyTypeKey, ReviewCoverProps } from "@/types/review-types";
import { TaxDetail } from "@/types/TaxDetailType";
import QuoteCoverTypeMap from "@/utils/gtm/cover-type-map";
import QuoteDataMap from "@/utils/gtm/quote-data-map";
import { formatPolicyStartDate } from "@/utils/review.utils";
import { isSameDate } from "@/utils/travel-date.utils";

import Style from "./review-cover.module.css";
import ReferFriendModal from "./review-modals/refer-friend-modal";
import RemoveSureModal from "./review-modals/remove-sure-popup";

export default function ReviewCover({
  title,
  btnHeaderLabel,
  btnChangeCover,
  totalPlicyPriceText,
  installmentsText,
  btnRemoveTwo,
  btnRemoveOne,
  totalPayText,
  btnReffereFriend,
  removeModalTitle,
  removeModalContent,
  removeModalButtonOne,
  removeModalButtonTwo,
  btnLinkLabel,
  changeCoverLink,
  toatalCreditChargetxt,
  interesttxt,
  reviewCoverPragraphOne,
  reviewCoverPragraphOneWithPCLMessage,
  reviewCoverPragraphTwo,
  acoSectionContent,
}: Readonly<ReviewCoverProps>) {
  const { push } = useRouter();
  const isdesktop = useMediaQuery("(min-width: 904px)");
  const { current } = useWizard();
  const { t } = useWizardTranslation();
  const [showOnDesktop, setShowOnDesktop] = useState(0);
  const { attributes, version, referenceId, type } = useSelector(
    (state: RootState) => state.quote
  );
  const isQuoteDisabled = useQuoteDisabled();
  const { paymentDetails, priceResult, tripDetails } = attributes;
  const freeACOCode = paymentDetails?.discounts?.offerDetails?.freeACOCode;
  const partnerCode = attributes?.partnerCode;
  const dispatch = useDispatch();
  const [policyTypeAmount, setPolicyTypeAmount] = useState<{
    amount?: number;
    type?: PolicyTypeKey;
  }>();
  const [cover, setCover] = useState<OptionalExtra[] | undefined>([]);
  const [taxDetails, setTaxDetails] = useState<TaxDetail[] | undefined>([]);
  const [isOpenRemove, setIsOpenRemove] = useState(false);
  const [isOpenRemovePromoVoucher, setIsOpenRemovePromoVoucher] =
    useState(false);

  const [isReferModalOpen, setIsReferModalOpen] = useState(false);
  const [buttonDisabled, setButtonDisabled] = useState<boolean>(false);
  const [nullPromoCode, setNullPromoCode] = useState<string | undefined>();
  const [nullVoucherCode, setNullVoucherCode] = useState<
    SubmitVoucherCode[] | undefined
  >();
  const [removePromoVoucherData, setRemovePromoVoucherData] = useState<{
    type: "PROMO" | "VOUCHER";
    index?: number;
  }>();
  const [coverRemove, setCoverRemove] = useState<OptionalExtra | undefined>();
  const [success, fetchRemoveCover, loadingRemoveCover]: any = useRemoveCover(
    version,
    referenceId,
    coverRemove,
    cover,
    setIsOpenRemove
  );
  const { hideLoading, showLoading } = useLoading();
  const promoCodeTrimEnabled = Boolean(
    current?.brandSpecificParams?.promoCodeTrimEnabled
  );
  const [newQuote, submitVoucherCodes, errorVoucher]: any = useSubmitCodes(
    { version, type, attributes, referenceId },
    nullPromoCode as string,
    nullVoucherCode as SubmitVoucherCode[],
    setButtonDisabled,
    undefined,
    promoCodeTrimEnabled
  );

  const [newQuotePromo, submitPromoCode, errorPromo]: any = useSubmitCodes(
    { version, type, attributes, referenceId },
    nullPromoCode as string,
    [],
    setButtonDisabled,
    undefined,
    promoCodeTrimEnabled
  );
  const [initiateGtmUpdate, setInitiateGtmUpdate] = useState(false);

  const acoMapping = useMemo(() => {
    if (!acoSectionContent?.acoItem) return {};

    const acoData = getAcoData(acoSectionContent.acoItem);
    const mapping: Record<string, string> = {};

    acoData.forEach((aco) => {
      mapping[aco.code] = aco.data.acoTitle;
    });

    return mapping;
  }, [acoSectionContent]);

  // GTM Trigger
  let gtmQuoteDataReview = null;
  let policyPackagesReview = null;
  if (attributes) {
    gtmQuoteDataReview = QuoteDataMap(
      attributes,
      "view_cart",
      "Review order",
      referenceId
    );
    policyPackagesReview = QuoteCoverTypeMap(attributes);
  }
  useGtmQuoteReviewOption({
    quoteReviewData: gtmQuoteDataReview,
    policyItems: policyPackagesReview,
    isReady: initiateGtmUpdate,
  });

  useEffect(() => {
    if (paymentDetails?.discounts?.promoCode) {
      setNullPromoCode(paymentDetails?.discounts?.promoCode?.code);
    }
  }, [paymentDetails]);

  useEffect(() => {
    if (nullPromoCode === "") {
      submitPromoCode();
    }
  }, [nullPromoCode]);

  useEffect(() => {
    if (nullVoucherCode) submitVoucherCodes();
  }, [nullVoucherCode]);

  useEffect(() => {
    if (newQuote) {
      const updatedQuote = {
        ...newQuote,
        attributes: {
          ...(newQuote?.attributes ?? attributes),
          paymentDetails: {
            ...newQuote.attributes.paymentDetails,
            optOutAutoRenewal: attributes?.paymentDetails?.optOutAutoRenewal,
          },
        },
      };
      dispatch(updateQuote(updatedQuote));
      setIsOpenRemovePromoVoucher(false);
    }
  }, [dispatch, newQuote]);

  useEffect(() => {
    if (newQuotePromo) {
      const updatedQuote = {
        ...newQuotePromo,
        attributes: {
          ...(newQuotePromo?.attributes ?? attributes),
          paymentDetails: {
            ...newQuotePromo.attributes.paymentDetails,
            optOutAutoRenewal: attributes?.paymentDetails?.optOutAutoRenewal,
          },
        },
      };
      dispatch(updateQuote(updatedQuote));
      setIsOpenRemovePromoVoucher(false);
    }
  }, [dispatch, newQuotePromo]);

  useEffect(() => {
    if (buttonDisabled || loadingRemoveCover) {
      showLoading();
    } else {
      hideLoading();
    }
  }, [buttonDisabled, loadingRemoveCover]);

  useEffect(() => {
    if (isdesktop) setShowOnDesktop(1);
    if (!isdesktop) setShowOnDesktop(2);
  }, [isdesktop]);

  useEffect(() => {
    if (priceResult && tripDetails) {
      const policyTypeAmountFilter =
        priceResult?.policyPackagePrice?.filter(
          (item) =>
            item?.policyPackage === tripDetails?.policyPackage &&
            item?.policyType === tripDetails?.policyType
        ) ?? [];

      if (tripDetails?.product === "CRUISE") {
        switch (tripDetails?.policyPackage) {
          case "CLASSIC":
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Classic Cruise",
            });
            break;
          case "DELUXE":
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Deluxe Cruise",
            });
            break;
          default:
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Classic",
            });
        }
      }

      if (tripDetails?.product === "CORE") {
        switch (tripDetails?.policyPackage) {
          case "COMPREHENSIVE":
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Comprehensive",
            });
            break;
          case "BASIC":
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Basic",
            });
            break;
          case "SIGNATURE":
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Signature",
            });
            break;
          case "ESSENTIALS":
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Essentials",
            });
            break;
          case "CLASSIC":
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Classic",
            });
            break;
          case "DELUXE":
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Deluxe",
            });
            break;
          default:
            setPolicyTypeAmount({
              amount: policyTypeAmountFilter[0]?.total,
              type: "Comprehensive",
            });
        }
      }

      const selectedCovers = priceResult?.optionalExtras?.filter(
        (item) => item?.price[0].selected
      );
      const coversWithDisplayNames = selectedCovers?.map((item) => ({
        ...item,
        displayName: acoMapping[item.code] || item?.price[0]?.name,
      }));
      setCover(coversWithDisplayNames);
      setTaxDetails(priceResult?.taxDetails || []);
      setInitiateGtmUpdate(true);
    }
  }, [priceResult, tripDetails, acoMapping]);

  useEffect(() => {
    if (coverRemove) {
      setIsOpenRemove(true);
    }
  }, [coverRemove, success]);

  useEffect(() => {
    if (!isOpenRemove) {
      setCoverRemove(undefined);
    }
  }, [isOpenRemove]);

  useEffect(() => {
    if (success) {
      dispatch(updateQuote(success));
      setIsOpenRemove(false);
      setCoverRemove(undefined);
    }
  }, [dispatch, success]);

  useEffect(() => {
    if (removePromoVoucherData) setIsOpenRemovePromoVoucher(true);
  }, [removePromoVoucherData]);

  useEffect(() => {
    if (errorPromo || errorVoucher) {
      setIsOpenRemovePromoVoucher(false);
      setRemovePromoVoucherData(undefined);
      if (attributes?.paymentDetails?.discounts?.promoCode) {
        setNullPromoCode(
          attributes?.paymentDetails?.discounts?.promoCode?.code
        );
      } else {
        setNullPromoCode("");
      }
    }
  }, [errorPromo, errorVoucher]);

  const submitRemove = () => {
    fetchRemoveCover();
  };

  const onClickRemovePromoVoucher = () => {
    if (removePromoVoucherData?.type === "PROMO") {
      setNullPromoCode("");
      setRemovePromoVoucherData(undefined);
    } else if (
      removePromoVoucherData?.type === "VOUCHER" &&
      removePromoVoucherData?.index
    ) {
      setNullVoucherCode([{ code: "", index: removePromoVoucherData.index }]);
      setRemovePromoVoucherData(undefined);
    }
  };

  const isAMT: boolean =
    attributes?.paymentDetails?.paymentOption === "SPREAD_THE_COST";

  const isPaymentOption = attributes?.paymentDetails?.paymentOption;

  const renderHelpButtonOverlay = () => {
    return <HelpOverLayButton />;
  };

  const renderLogo = () => {
    return <Logo color="white" size="xl" />;
  };

  const modifiedReviewCoverPragraphOne = useMemo(() => {
    if (!tripDetails?.startDate || !reviewCoverPragraphOneWithPCLMessage)
      return reviewCoverPragraphOne;

    return isSameDate(new Date(tripDetails.startDate))
      ? reviewCoverPragraphOne
      : reviewCoverPragraphOneWithPCLMessage.replace(
          "&lt;POLICY_START_DATE&gt;",
          formatPolicyStartDate(tripDetails.startDate)
        );
  }, [tripDetails?.startDate]);

  return (
    <div>
      <RemoveSureModal
        content={{
          removeModalTitle,
          removeModalContent,
          removeModalButtonOne,
          removeModalButtonTwo,
        }}
        setIsOpen={setIsOpenRemove}
        isOpen={isOpenRemove}
        coverName={coverRemove?.displayName || coverRemove?.price[0]?.name}
        submitRemove={submitRemove}
      />
      <RemoveSureModal
        content={{
          removeModalTitle,
          removeModalContent,
          removeModalButtonOne,
          removeModalButtonTwo,
        }}
        setIsOpen={setIsOpenRemovePromoVoucher}
        isOpen={isOpenRemovePromoVoucher}
        coverName={t("promo_or_voucher_code", "promo or voucher code")}
        submitRemove={onClickRemovePromoVoucher}
      />
      <ReferFriendModal
        isOpen={isReferModalOpen}
        setIsOpen={setIsReferModalOpen}
      />
      {showOnDesktop === 2 && (
        <div className="  bg-dark-surface-accent-1-primary  text-neutral-50 rounded-t-radius-xxl min-h-[64px] md:h-[80px] relative">
          {renderHelpButtonOverlay()}
          {renderLogo()}
        </div>
      )}
      <div className=" pt-spacing-xs pb-spacing-l px-spacing-xl md:p-spacing-xxl md:pt-0 lg:p-spacing-xxl w-full">
        <div className="font-header-font md:text-[39px] text-[23px] lg:leading-[44.85px] text-teal-50 text-center mb-[24px]">
          {title}
        </div>
        <div className=" mb-[32px] flex justify-center">
          <LabelButtonWrapper
            data-testid="review-cover-header-label-button"
            id="review-cover-header-label-button"
            isDisabled={isQuoteDisabled}
            label={btnHeaderLabel ?? " "}
            hierarchy="secondary"
            semanticColor="Dark Background"
            className="font-body-font px-spacing-l py-spacing-s text-teal-50 border-neutral-50 !max-h-[40px] !w-fit "
            type="button"
            onClick={() => {
              push(btnLinkLabel ?? "/");
            }}
          />
        </div>
        {!isPaymentOption ? (
          <div> Loading...</div>
        ) : (
          <div>
            <div className=" flex justify-between items-start mb-spacing-xs ">
              <div className="font-body-font text-[18px] font-weight lg:leading-[27px] ">
                {policyTypeAmount?.type ?? ""}
              </div>
              <div className=" font-body-font text-[18px] font-bold lg:leading-[27px] ">
                {policyTypeAmount?.amount &&
                  `${
                    (current.brandSpecificParams?.currencySymbol as string) ??
                    ""
                  }${Number(policyTypeAmount?.amount).toFixed(2)}`}
              </div>
            </div>
            <div className="font-body-font text-[18px] font-weight lg:leading-[27px] ">
              {attributes?.tripDetails?.policyType === "ANNUAL_MULTI_TRIP"
                ? t("annual_multi_trip", "Annual Multi Trip")
                : t("single_trip", "Single Trip")}
            </div>
            <div className={`${Style.tertiary_light} `}>
              <LabelButtonWrapper
                data-testid="review-cover-change-cover-button"
                id="review-cover-change-cover-button"
                isDisabled={isQuoteDisabled}
                label={btnChangeCover}
                hierarchy="tertiary"
                semanticColor="Dark Background"
                className={`${Style.whiteBtn} !px-0 text-[16px] font-body-font font-[600] leading-[19.49px] text-surface-neutral-option-1 mb-spacing-l`}
                type="button"
                onClick={() => {
                  push(changeCoverLink ?? "/");
                }}
              />
            </div>

            {attributes?.paymentDetails?.discounts?.promoCode?.valid && (
              <div className=" flex justify-between items-start mb-spacing-m ">
                <div>
                  <div className="font-body-font text-[18px] font-weight lg:leading-[27px] ">
                    {attributes?.paymentDetails?.discounts?.promoCode?.code}
                  </div>
                  {!partnerCode && (
                    <LabelButtonWrapper
                      data-testid="review-cove-promo-remove-button"
                      id="review-cove-promo-remove-button"
                      isDisabled={buttonDisabled || isQuoteDisabled}
                      label={btnRemoveOne}
                      hierarchy="tertiary"
                      semanticColor="Dark Background"
                      className={`${Style.removeBtn} !px-0 text-[16px] font-body-font font-[600] leading-[19.49px] !text-dark-text-critical`}
                      type="button"
                      onClick={() => {
                        setRemovePromoVoucherData({
                          type: "PROMO",
                        });
                      }}
                    />
                  )}
                </div>
                <div className=" font-body-font text-[18px] font-bold lg:leading-[27px] text-right">
                  {`- ${
                    (current.brandSpecificParams?.currencySymbol as string) ??
                    ""
                  }${Math.abs(
                    attributes?.paymentDetails?.discounts?.promoCode?.value
                  ).toFixed(2)}`}
                </div>
              </div>
            )}

            {attributes?.paymentDetails?.discounts?.voucher?.map((item) => (
              <div key={item.code}>
                {!item.message ? (
                  <div className=" flex justify-between items-start mb-spacing-m ">
                    <div>
                      <div className="font-body-font text-[18px] font-weight lg:leading-[27px] ">
                        {item?.code}
                      </div>
                      <LabelButtonWrapper
                        data-testid="review-voucher-remove-button"
                        id="review-voucher-remove-button"
                        isDisabled={buttonDisabled || isQuoteDisabled}
                        label={btnRemoveOne}
                        hierarchy="tertiary"
                        semanticColor="Dark Background"
                        className={`${Style.removeBtn} !px-0 text-[16px] font-body-font font-[600] leading-[19.49px] !text-dark-text-critical`}
                        type="button"
                        onClick={() => {
                          setRemovePromoVoucherData({
                            type: "VOUCHER",
                            index: item.index,
                          });
                        }}
                      />
                    </div>
                    <div className=" font-body-font text-[18px] font-bold lg:leading-[27px] text-right">
                      {`- ${
                        (current.brandSpecificParams
                          ?.currencySymbol as string) ?? ""
                      }${Math.abs(item?.amount ?? 0).toFixed(2)}`}
                    </div>
                  </div>
                ) : null}
              </div>
            ))}

            {cover && cover[0] && (
              <div className="h-0.25 flex-1 border-t border-solid border-neutral-500 my-spacing-l" />
            )}
            {cover?.map((item) => {
              return (
                <div key={item?.code}>
                  <div className=" flex justify-between  items-center mb-spacing-m">
                    <div>
                      <div className="font-body-font text-[18px] font-weight lg:leading-[27px]">
                        {item?.displayName || item?.price[0]?.name}
                      </div>
                      {item?.code !== freeACOCode && (
                        <LabelButtonWrapper
                          data-testid={`${item?.code
                            .toLowerCase()
                            .replace(/_/g, "-")}-review-cover-remove-button`}
                          id={`${item?.code
                            .toLowerCase()
                            .replace(/_/g, "-")}-review-cover-remove-button`}
                          isDisabled={isQuoteDisabled}
                          label={btnRemoveTwo}
                          hierarchy="tertiary"
                          semanticColor="Dark Background"
                          className={`${Style.removeBtn} !px-0 text-[16px] font-body-font font-[600] leading-[19.49px] !text-dark-text-critical`}
                          type="button"
                          onClick={() => {
                            setCoverRemove(item);
                          }}
                        />
                      )}
                    </div>
                    <div className=" font-body-font text-[18px] font-bold lg:leading-[27px] text-right">
                      {(current.brandSpecificParams
                        ?.currencySymbol as string) ?? ""}
                      {Number(item?.price[0]?.sellPrice).toFixed(2)}
                    </div>
                  </div>
                </div>
              );
            })}

            {isAMT && (
              <>
                <div className="h-0.25 flex-1 border-t border-solid border-neutral-500 my-spacing-l" />

                <div className=" flex justify-between  items-center mb-spacing-m">
                  <div>
                    <div className="font-body-font text-[18px] font-weight lg:leading-[27px]">
                      {totalPlicyPriceText}
                    </div>
                  </div>
                  <div className=" font-body-font text-[18px] font-bold lg:leading-[27px] text-right">
                    {(current.brandSpecificParams?.currencySymbol as string) ??
                      ""}
                    {isAMT
                      ? Number(
                          attributes?.paymentDetails?.paymentOptions[0]
                            ?.cardPayment?.premiumCreditPayment?.[0]?.pcl
                            ?.totalCost
                        ).toFixed(2)
                      : Number(
                          attributes?.paymentDetails?.paymentOptions[0]
                            ?.cardPayment?.card?.price
                        ).toFixed(2)}
                  </div>
                </div>
              </>
            )}

            <div className="h-0.25 flex-1 border-t border-solid border-neutral-500 my-spacing-l" />
            <div className=" flex justify-between items-start self-stretch mb-spacing-m">
              <div className="font-body-font text-[18px] font-bold lg:leading-[27px] ">
                {totalPayText}
                {isAMT ? " today" : ""}
              </div>
              <div className=" font-body-font text-[25px] font-bold lg:leading-[28.75px] text-right">
                {attributes &&
                  ` ${
                    (current.brandSpecificParams?.currencySymbol as string) ??
                    ""
                  }${
                    isAMT
                      ? Number(
                          attributes?.paymentDetails?.paymentOptions[0]
                            ?.cardPayment?.premiumCreditPayment[0]?.pcl
                            ?.depositAmount
                        ).toFixed(2) ?? ""
                      : Number(
                          attributes?.paymentDetails?.paymentOptions[0]
                            ?.cardPayment?.card?.price
                        ).toFixed(2) ?? ""
                  }`}
              </div>
            </div>

            {/* Tax Details Section */}
            {current.brandSpecificParams?.showTaxDetails &&
              taxDetails &&
              taxDetails.length > 0 && (
                <>
                  <div className="h-0.25 flex-1 border-t border-solid border-neutral-500 my-spacing-l" />
                  {taxDetails.map((tax) => (
                    <div
                      key={tax.name}
                      className="flex justify-between items-center mb-spacing-m"
                    >
                      <div className="font-body-font text-[18px] font-weight lg:leading-[27px]">
                        {tax.name}
                      </div>
                      <div className="font-body-font text-[18px] font-bold lg:leading-[27px] text-right">
                        {(current.brandSpecificParams
                          ?.currencySymbol as string) ?? ""}
                        {Number(tax.value).toFixed(2)}
                      </div>
                    </div>
                  ))}
                </>
              )}

            {isAMT && (
              <div>
                <div className=" flex justify-between  items-center mb-spacing-m">
                  <div>
                    <div className="font-body-font text-[18px] font-weight lg:leading-[27px]">
                      {toatalCreditChargetxt ?? "  Total credit charge"}
                    </div>
                  </div>
                  <div className=" font-body-font text-[18px] font-bold lg:leading-[27px] text-right">
                    {(current.brandSpecificParams?.currencySymbol as string) ??
                      ""}
                    {Number(
                      attributes?.paymentDetails?.paymentOptions[0]?.cardPayment
                        ?.premiumCreditPayment[0]?.pcl?.costOfCredit
                    ).toFixed(2)}
                  </div>
                </div>
                <div className=" flex justify-between  items-center mb-spacing-m">
                  <div>
                    <div className="font-body-font text-[18px] font-weight lg:leading-[27px]">
                      {interesttxt ?? "Interest"}
                    </div>
                  </div>
                  <div className=" font-body-font text-[18px] font-bold lg:leading-[27px] text-right">
                    {Number(
                      attributes?.paymentDetails?.paymentOptions[0]?.cardPayment
                        ?.premiumCreditPayment[0]?.pcl?.annualPercentageRate
                    ).toFixed(1)}
                    % APR
                  </div>
                </div>

                <div className=" flex justify-between  items-center mb-spacing-m">
                  <div>
                    <div className="font-body-font text-[18px] font-weight lg:leading-[27px]">
                      {installmentsText}
                    </div>
                  </div>
                  <div className=" font-body-font text-[18px] font-bold lg:leading-[27px] text-right">
                    {(current.brandSpecificParams?.currencySymbol as string) ??
                      ""}
                    {Number(
                      attributes?.paymentDetails?.paymentOptions[0]?.cardPayment
                        ?.premiumCreditPayment[0]?.pcl?.collectionAmount
                    ).toFixed(2)}
                  </div>
                </div>
              </div>
            )}
            {current.uiElementControls?.showReferFriendButton && (
              <div className="lg:flex lg:flex-col gap-spacing-m ">
                <div>
                  <LabelButtonWrapper
                    data-testid="review-cover-refer-friend-button"
                    id="review-cover-refer-friend-button"
                    isDisabled={false}
                    label={btnReffereFriend}
                    hierarchy="tertiary"
                    semanticColor="Dark Background"
                    className={`${Style.whiteBtn} !px-0 text-[16px] font-body-font font-[600] leading-[19.49px] text-surface-neutral-option-1`}
                    type="button"
                    onClick={() => {
                      setIsReferModalOpen(true);
                    }}
                  />
                </div>
              </div>
            )}
            <div className="mt-spacing-xl">
              {isAMT && (
                <div className="mb-spacing-xl !font-normal">
                  <RichText richText={modifiedReviewCoverPragraphOne} />
                </div>
              )}
              <div className="!font-normal text-[14px]">
                <RichText richText={reviewCoverPragraphTwo} />
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  );
}
